// src/components/Products/FeedbackForm/services/publicApi.js
import axios from 'axios';
import { getApiBaseUrl } from '../../../../utils/apiBaseUrl';

// Base do BACKEND
const API_URL = getApiBaseUrl();

// Instância PRÓPRIA para as rotas públicas do Feedback Form
const feedbackApiPublic = axios.create({
  baseURL: API_URL,
  withCredentials: false,
});

/**
 * Obtém dados públicos do restaurante via nosso backend:
 * Retorna { id, nome } pelo menos.
 * Em erro, devolve um fallback “Restaurante #ID” para não travar a tela.
 */
export async function getPublicRestaurante(slug) {
  try {
    const { data: payload } = await feedbackApiPublic.get(
      `/feedback-form/public/restaurante/${slug}`
    );

    // Normalizações comuns: objeto direto, {data:[...]}, ou array
    if (payload && typeof payload === 'object' && !Array.isArray(payload)) {
      if (Array.isArray(payload.data) && payload.data.length) {
        return payload.data[0];
      }
      return payload;
    }
    if (Array.isArray(payload) && payload.length) {
      return payload[0];
    }
  } catch (err) {
    console.warn('getPublicRestaurante error:', err?.response?.status, err?.message);
  }

  return { id: slug, nome: `Restaurante #${slug}` };
}

const publicApi = {
  getPublicRestaurante,
};

export default publicApi;